/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { VoiceArticleAddRequest } from '../../models/voice-article-add-request';

export interface AddVoiceSessionArticle$Params {
  organizationSiteKey: KeyType;
  voiceSessionKey: KeyType;
      body: VoiceArticleAddRequest
}

export function addVoiceSessionArticle(http: HttpClient, rootUrl: string, params: AddVoiceSessionArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'articleKey': string;
'deliveryNoteKey': string;
}>> {
  const rb = new RequestBuilder(rootUrl, addVoiceSessionArticle.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('voiceSessionKey', params.voiceSessionKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'articleKey': string;
      'deliveryNoteKey': string;
      }>;
    })
  );
}

addVoiceSessionArticle.PATH = '/organization-sites/{organizationSiteKey}/voice-sessions/{voiceSessionKey}/articles/add';
